export class DetalheProcessamentoFilter {
    carteiraId:number;
    dataInicio: Date;
    dataFim: Date;

    constructor(carteiraId: number, dataInicio?: Date, dataFim?: Date) {
        this.carteiraId = carteiraId;
        this.dataInicio = dataInicio;
        this.dataFim = dataFim;
    }
}
